<template>
  <!-- header -->
  <div
    id="headerWrap"
    :class="['header', { on_main: transBg && !(family || open) }]"
    ref="headerRef"
  >
    <div class="header_wrap" :class="{ open2: family }">
      <h1>
        <a :href="$t('main[0].path')"
          ><img :src="`${resources}img/logo_kop.png`" alt="한국오션플랫폼"
        /></a>
      </h1>

      <!-- <a href="#" class="btn_family" @click.prevent="clickFamily"
        ><div class="petal_wrap">
          <span class="petal"></span><span class="petal"></span
          ><span class="petal"></span><span class="petal"></span></div
      ></a> -->
      <div class="family_wrap">
        <div class="family_inner">
          <em>FAMILY COMPANY</em>
          <ul>
            <li>
              <a
                :href="$t('footer.select[1].options[0].path')"
                title="새 창으로 이동"
                target="_blank"
                rel="noreferrer noopener"
              >
                <div class="img_wrap">
                  <img :src="`${resources}img/img_family01.png`" alt="" />
                </div>
                <strong>금융, 도시가스, 건설</strong>
                <p>인류를 위해 더 나은 세상을 만들어 나갑니다.</p>
              </a>
            </li>
            <li>
              <a
                :href="$t('footer.select[1].options[1].path')"
                title="새 창으로 이동"
                target="_blank"
                rel="noreferrer noopener"
              >
                <div class="img_wrap">
                  <img :src="`${resources}img/img_family02.png`" alt="" />
                </div>
                <strong>도시가스</strong>
                <p>따뜻함과 행복을 드리는 생활에너지기업</p>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="gnb_wrap" ref="gnbRef" :class="{ open }">
        <div class="gnb_hbg"></div>
        <ul class="gnb">
          <li v-for="(menu, idx) in $t('header')" :key="`header-${idx}`">
            <router-link :to="{ path: menu.path }">{{ menu.name }}</router-link>
            <ul>
              <li
                v-for="(sub, sidx) in menu.subs"
                :key="`header-${idx}-${sidx}`"
              >
                <router-link :to="{ path: sub.path }">{{
                  sub.name
                }}</router-link>
                <!-- <div v-if="sub.tabs">
                  <router-link
                    v-for="(tab, tidx) in sub.tabs"
                    :to="{ path: tab.path, hash: tab.hash }"
                    :key="`header-${idx}-${sidx}-${tidx}`"
                    >{{ tab.name }}</router-link
                  >
                </div> -->
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import mixin from '@/mixins';

let timeId;

/**
 * @module components/pc/Top
 * @vue-data {Number} st=0 - 브라우저 스크롤 세로 위치
 * @vue-computed {Boolean} isMain - 메인인지 유무
 * @vue-computed {Boolean} open - 오픈 유무
 * @vue-computed {Boolean} family - 패밀리 영역 열림 유무
 * @vue-computed {Number} scrollTop - 브라우저 스크롤 세로 위치
 * @vue-computed {Boolean} transBg - 투명 bg 유무
 */
export default {
  data() {
    return {
      st: 0
    };
  },
  mixins  : [mixin],
  computed: {
    ...mapState('main', {
      isMain: 'is'
    }),
    ...mapState('view', {
      open     : (state) => state.header.open,
      family   : (state) => state.header.family,
      scrollTop: 'scrollTop'
    }),
    transBg() {
      return this.isMain && this.st === 0;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initGnb();

      const { height } = this.$refs.headerRef.getBoundingClientRect();
      this.setHeaderHeight(height);
    });
  },
  watch: {
    scrollTop(value) {
      this.st = value;
    }
  },
  methods: {
    ...mapMutations('view', {
      setHeaderOpen  : 'SET_HEADER_OPEN',
      setHeaderHeight: 'SET_HEADER_HEIGHT',
      setHeaderFamily: 'SET_HEADER_FAMILY'
    }),
    /**
     * gnb on/off 이벤트 바인딩
     */
    initGnb() {
      const gnb = this.$refs.gnbRef;

      gnb.addEventListener('mouseenter', this.openGnb);
      gnb.addEventListener('mouseleave', this.closeGnb);
    },
    /**
     * 패밀리 메뉴 클릭 이벤트
     */
    clickFamily() {
      this.setHeaderFamily(!this.family);
    },
    /**
     * gnb 열기
     */
    openGnb() {
      if (timeId) {
        clearTimeout(timeId);
      }
      this.setHeaderOpen(true);
    },
    /**
     * gnb 닫기
     */
    closeGnb() {
      timeId = setTimeout(() => {
        this.setHeaderOpen(false);
      }, 300);
    }
  }
};
</script>

<style lang="scss" scoped>
.gnb_wrap {
  .gnb_hbg {
    display: none;
  }

  &.open {
    .gnb_hbg {
      display: block;
    }
  }
}
</style>
